import { getAdvertiserSASuggestions } from 'app/sponsoredAds/services/autosuggestServices';
import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import withInputErrorMessage from '../withInputErrorMessage';
import autosuggestFactory from './autosuggestFactory';
import withAutosuggestWrapper from './withAutosuggestWrapper';
import withMultiSelectAutosuggest from './withMultiSelectAutosuggest';

const AdvertiserAutosuggestSA = autosuggestFactory({
   apiPromise: getAdvertiserSASuggestions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabel,
   defaultPlaceholder: 'Search Advertiser...',
});

export default withAutosuggestWrapper(withInputErrorMessage(AdvertiserAutosuggestSA));
export const AdvertiserMultiSelectSA = withMultiSelectAutosuggest(AdvertiserAutosuggestSA);
